import { ShieldCheck, User } from "lucide-react";
import { Image } from "@openai/apps-sdk-ui/components/Image";

/**
 * Owner information card
 */
export function DetailOwnerCard({
  ownerName,
  ownerType,
  ownerLogo,
  ownerVerified,
  isDark,
}) {
  if (!ownerName) return null;

  const ownerTypeLabel =
    ownerType === "corporate"
      ? "Emlak Ofisi"
      : ownerType === "individual"
      ? "Bireysel"
      : ownerType;

  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-xl border ${
        isDark ? "border-white/10 bg-white/5" : "border-gray-100 bg-gray-50"
      }`}
    >
      {/* Owner Logo/Avatar */}
      {ownerLogo ? (
        <div className="h-10 w-10 rounded-lg overflow-hidden flex-shrink-0">
          <Image src={ownerLogo} alt={ownerName} className="h-full w-full object-cover" />
        </div>
      ) : (
        <div
          className={`h-10 w-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
            isDark ? "bg-white/10" : "bg-gray-200"
          }`}
        >
          <User className="h-5 w-5" strokeWidth={1.5} />
        </div>
      )}

      {/* Owner Info */}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className={`text-sm font-medium truncate ${isDark ? "text-white" : "text-gray-900"}`}>
            {ownerName}
          </span>
          {ownerVerified && (
            <ShieldCheck className="h-4 w-4 text-emerald-500 flex-shrink-0" strokeWidth={2} />
          )}
        </div>
        {ownerTypeLabel && (
          <div className={`text-xs ${isDark ? "text-white/50" : "text-gray-500"}`}>
            {ownerTypeLabel}
          </div>
        )}
      </div>
    </div>
  );
}

export default DetailOwnerCard;
